import { Fragment, ReactElement } from "react";

import { useEntityPropertyKeyNormalized } from "@ryde/redux";
import { IEntityPropertyArrayObject, RydeUiUnit } from "@ryde/shared";

import { Collapse } from "../collapse";
import { EntityProperties } from "./entity-properties";
import { EntityPropertyPlaceholderValue } from "./entity-property-placeholder-value";
import { useEntityPropertyCollapse } from "./use-entity-property-collapse";

interface IEntityPropertyArrayObjectProps {
  entity?: RydeUiUnit;
  entityProperty: IEntityPropertyArrayObject;
}

export const EntityPropertyArrayObject = ({
  entity,
  entityProperty,
}: IEntityPropertyArrayObjectProps): ReactElement => {
  const propertyKey = useEntityPropertyKeyNormalized({
    entity,
    entityProperty,
  });
  const { isCollapsed, onToggle } = useEntityPropertyCollapse(
    !!entityProperty.properties?.length,
  );

  return (
    <Collapse
      isSkipMaxHeight
      isInner
      isCollapsed={isCollapsed}
      onToggleCollapsed={onToggle}
      CollapseHeader={
        <EntityPropertyPlaceholderValue
          label={propertyKey}
          value="[...]"
          isOpen={isCollapsed}
        />
      }
    >
      {entityProperty?.properties?.map((childProperties, childIndex) => {
        return (
          <Fragment key={entityProperty.path + childIndex}>
            {entityProperty.itemLabels?.[childIndex] && (
              <div className="entityProperty__item-label">
                {entityProperty.itemLabels[childIndex]}
              </div>
            )}
            <EntityProperties entity={entity} data={childProperties} />
          </Fragment>
        );
      })}
    </Collapse>
  );
};
